import { Context } from '../sdk/types';

enum LogType {
  UNCAUGHT_ERROR = 'UNCAUGHT_ERROR',
  UNHANDLED_REJECTION = 'UNHANDLED_REJECTION',
  PERFORMANCE = 'PERFORMANCE',
  CONTEXT = 'CONTEXT',
  ERROR_SCREEN = 'ERROR_SCREEN',
}

enum PerformanceType {
  LCP = 'LCP',
  TTFB = 'TTFB',
  INP = 'INP',
  NETWORK = 'NETWORK',
}

enum Rating {
  GOOD = 'good',
  NEEDS_IMPROVEMENT = 'needs improvement',
  POOR = 'poor',
}

interface PerformanceReport {
  value: number;
  rating?: Rating;
  metadata: object;
}

/** Performance report for largest contentful paint performance. */
interface LcpPerformanceReport extends PerformanceReport {
  metadata: {
    element?: string;
    size?: number;
    renderTime?: number;
    startTime?: number;
  };
}

/** Performance report for time to first byte performance. */
interface TtfbPerformanceReport extends PerformanceReport {
  metadata: {
    requestStart?: number;
    domComplete?: number;
  };
}

/** Performance report for interaction to next paint performance. */
interface InpPerformanceReport extends PerformanceReport {
  metadata: {
    processingStart?: number;
    processingEnd?: number;
    startTime?: number;
  };
}

/** Performance report for network performance. */
interface NetworkPerformanceReport extends PerformanceReport {
  metadata: {
    url: string;
    tcpHandshakeTime: number;
    dnsLookupTime: number;
    requestTime: number;
    fetchTime: number;
  };
}

interface LogApi {
  /**
   * Logs an error when an error screen is rendered.
   *
   * @param error A string describing the error.
   * @param metadata (Optional) A flexible key-value map for additional data.
   */
  logErrorScreen: (error: string, metadata?: { screenName?: string }) => void;
}

interface InternalLogApi {
  logUncaughtError: (error: string) => void;
  logUnhandledRejection: (rejection: string) => void;
  logLcpPerformance: (lcpPerformanceReport: LcpPerformanceReport) => void;
  logTtfbPerformance: (ttfbPerformanceReport: TtfbPerformanceReport) => void;
  logInpPerformance: (inpPerformanceReport: InpPerformanceReport) => void;
  logNetworkPerformance: (
    networkPerformanceReport: NetworkPerformanceReport
  ) => void;
  logContext: (context: Context) => void;
}

export {
  InpPerformanceReport,
  InternalLogApi,
  LcpPerformanceReport,
  LogApi,
  LogType,
  NetworkPerformanceReport,
  PerformanceType,
  Rating,
  TtfbPerformanceReport,
};
